import { RetryLink } from "@apollo/client/link/retry";
const retryLink = new RetryLink({
    delay: {
        initial: 300,
        max: 2000,
        jitter: true,
    },
    attempts: {
        max: 3,
        retryIf(error) {
            // Only retry on server errors (5xx status codes)
            // If statusCode is undefined, don't retry by default
            const statusCode = error?.statusCode;
            return statusCode !== undefined && statusCode >= 500;
        },
    },
});
export default retryLink;
